module.exports = __webpack_public_path__ + "img/picture.6bc0f570.svg";